import { FC } from 'react';
import ProSwitch, { SwitchProps } from './switch';

export type ISwitchComponent = FC<
  SwitchProps & React.RefAttributes<HTMLElement>
>;

const TransSwitch = ProSwitch as ISwitchComponent;

export default TransSwitch;
